export default [
  {
    title: 'ДомоПоиск',
    href: '/recipes',
    auth: true
  },{
    title: 'Мои подписки',
    href: '/subscriptions',
    auth: true
  },{
    title: 'Создать объект',
    href: '/recipes/create',
    auth: false
  },{
    title: 'Избранное',
    href: '/favorites',
    auth: true
  }, {
    title: 'Список покупок',
    href: '/cart',
    auth: true
  }
]